import { shouldIgnoreArticleBlur } from "./shouldIgnoreArticleBlur";

export default shouldIgnoreArticleBlur;
